module.exports = __webpack_public_path__ + "img/welcomes-preview-current-all-2.a891ee29.png";